/*
* @描述: 版本管理
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2024-01-17 10:09:30
*/
<template>
    <div class="page_container">
        <div class="add_btn_wrap">
            <el-button @click="handleClickAddVersion" icon="el-icon-plus" size="small" type="primary">
                新增版本号
            </el-button>
        </div>
        <el-table :data="versionList" :max-height="tableHeight" v-loading="loading">
            <el-table-column label="版本号" prop="version" show-overflow-tooltip width="200"></el-table-column>
            <el-table-column label="时间" prop="upper_date" width="150"></el-table-column>
            <el-table-column label="版本内容" prop="content">
                <template slot-scope="{row}">
                    <el-tooltip :content="row.content" placement="top">
                        <div class="version_content_wrap" v-text="row.content"></div>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100">
                <template slot-scope="{row}">
                    <el-button @click="handleClickEditVersion(row)"
                               icon="iconfont icon-bingji1"
                               type="text">
                    </el-button>
                    <el-button @click="handleClickDelVersion(row.version_id)"
                               icon="el-icon-delete"
                               type="text">
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="pagination.pageNum"
                       :page-size="pagination.pageSize"
                       :page-sizes="pagination.pageSizes"
                       :total="pagination.total"
                       @current-change="handleCurrentChange"
                       @size-change="handleSizeChange"
                       align="right"
                       background
                       layout="total, prev, pager,next,sizes">
        </el-pagination>
        <AddVersion v-if="addDrawerShow"
                    :add-visible.sync="addDrawerShow"
                    @success="getVersionList"/>
        <EditVersion v-if="editDrawerShow"
                    :edit-visible.sync="editDrawerShow"
                    :versionId="versionId"
                    @success="getVersionList"/>
    </div>
</template>
<script>
    import {delVersion, getVersions} from "@/api";
    import AddVersion from './addVersion'
    import EditVersion from './editVersion'

    export default {
        name: "Version",
        data() {
            return {
                isMobile: false,
                loading: false,
                versionList: [],
                pagination: {
                    total: 0,
                    pageSize: 15,
                    pageSizes: [15, 30, 50, 100],
                    pageNum: 1,
                },
                drawerSize: '35%',
                addDrawerShow: false,
                editDrawerShow: false,
                tableHeight: 600,
                resizeTimer: null,
                versionId: ''
            }
        },
        components: {AddVersion, EditVersion},
        created() {
            this.isMobileDevice()
            this.getVersionList()
            this.tableHeight = this.getTableHeight(275)
            window.onresize = () => {
                if (this.resizeTimer) {
                    clearTimeout(this.resizeTimer)
                }
                //开启定时器，节流函数
                this.resizeTimer = setTimeout(() => {
                    this.tableHeight = this.getTableHeight(275)
                    this.resizeTimer = null
                }, 100)
            }
        },
        mounted() {
        },
        methods: {
            // 判断是否是移动端
            isMobileDevice() {
                this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                if (this.isMobile) {
                    this.drawerSize = '100%'
                }
            },

            getTableHeight(height) {
                let tableHeight
                if (window.innerHeight - height <= 300) {
                    tableHeight = 300
                } else {
                    tableHeight = window.innerHeight - height
                }
                return tableHeight
            },

            getVersionList() {
                this.loading = true
                getVersions({
                    page: this.pagination.pageNum,
                    pageSize: this.pagination.pageSize,
                }).then(res => {
                    const {data, total} = res.data
                    this.versionList = data
                    this.pagination.total = total
                    this.loading = false
                }).catch(()=>{
                    this.loading = false
                })
            },

            handleSizeChange(val) {
                this.pagination.pageNum = 1;
                this.pagination.pageSize = val;
                this.getVersionList()
            },

            handleCurrentChange(val) {
                this.pagination.pageNum = val;
                this.getVersionList()
            },

            handleClickAddVersion() {
                this.addDrawerShow = true
            },

            handleClickEditVersion(row) {
                this.editDrawerShow = true
                this.versionId = row.version_id
            },

            handleClickDelVersion(id) {
                this.$confirm('删除版本号后不可恢复，是否继续？', '确定删除版本号吗？', {
                    iconClass: 'icon-a-fenzu31 iconfont',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: '删除',
                    customClass: 'title_icon_message_box'
                }).then(() => {
                    delVersion({
                        version_id: id
                    }).then(res => {
                        this.$message.success('删除成功')
                        this.getVersionList()
                    })
                }).catch(() => {

                })
            },
        },
    }
</script>
<style lang="scss" scoped>
  .add_btn_wrap {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    padding: 0 0 12px 0;
    text-align: right;
  }

  .version_content_wrap{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
